import React, { useMemo } from 'react'
import { StyleService, useStyleSheet } from '@src/style/service'
import { NavigationContainer } from '@src/screens/Common/containers'
import { NavigationBarAccessory } from '@src/components'

interface BiomarkerEntryScreenProps {
  children: React.ReactNode
  biomarkerName: string
  isEdit: boolean
  onDeletePress: () => void
}

export const BiomarkerEntryScreen = (props: BiomarkerEntryScreenProps) => {
  const { children, biomarkerName, isEdit, onDeletePress } = props
  const styles = useStyleSheet(themedStyles)

  const title = `${isEdit ? 'Edit ' : ''}${biomarkerName}`

  const rightAccessories = useMemo<NavigationBarAccessory[] | undefined>(() => {
    if (isEdit) {
      return [
        {
          iconDescriptor: { pack: 'eva', name: 'trash-outline' },
          iconTintColor: 'theme.primary.base',
          onPress: onDeletePress,
        },
      ]
    }
    return undefined
  }, [isEdit, onDeletePress])

  return (
    <NavigationContainer title={title} style={styles.container} rightAccessories={rightAccessories}>
      {children}
    </NavigationContainer>
  )
}

const themedStyles = StyleService.create({
  container: {
    backgroundColor: 'theme.background',
    flex: 1,
  },
})
